import { Component } from 'react'

/**
 * Base controller for the header components
 * @param {boolean} transparent
 * Turns the header's background, transparent, adds "Cadastre-se e receba 500 pontos" text, and adds box-shadow
 */

class BaseHeader extends Component {
	constructor(props) {
		super(props)
		this.state = { isMenuOpen: false, isTransparent: false }
	}
}

export default BaseHeader
